function mountSplideOnce(root, options) {
  if (!root || root.splide) return null;
  const instance = new Splide(root, options);
  instance.mount();
  return instance;
}

function destroySplidesIn(scope) {
  scope.querySelectorAll('.splide').forEach(el => {
    if (el.splide) {
      el.splide.destroy(true); 
    }
  });
}

function createCustomSplideArrows() {
  const arrows = document.createElement("div");
  arrows.classList.add("splide__arrows");

  const prevBtn = document.createElement("button");
  prevBtn.type = "button";
  prevBtn.className = "splide__arrow splide__arrow--prev";
  prevBtn.setAttribute("aria-label", "Previous");
  prevBtn.innerHTML = `
    <svg width="22" height="22" viewBox="0 0 24 24">
      <path d="M14.5 5.5 L8.5 12 L14.5 18.5" stroke="currentColor" fill="none"/>
    </svg>`;

  const nextBtn = document.createElement("button");
  nextBtn.type = "button";
  nextBtn.className = "splide__arrow splide__arrow--next";
  nextBtn.setAttribute("aria-label", "Next");
  nextBtn.innerHTML = `
    <svg width="22" height="22" viewBox="0 0 24 24">
      <path d="M9.5 5.5 L15.5 12 L9.5 18.5" stroke="currentColor" fill="none"/>
    </svg>`;

  arrows.appendChild(prevBtn);
  arrows.appendChild(nextBtn);
  return arrows;
}

function initBlogCarousels(scope = document) {
  destroySplidesIn(scope);

  scope.querySelectorAll('.js-featured-articles').forEach(el => {
    el.querySelectorAll('.splide__pagination, .splide__arrows').forEach(e => e.remove());
    mountSplideOnce(el, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: false,
      drag: true,
      rewind: false,
    });
  });

  scope.querySelectorAll('.js-latest-articles-carousel').forEach(el => {
    el.querySelectorAll('.splide__pagination, .splide__arrows').forEach(e => e.remove());
    if (!el.querySelector('.splide__arrows')) {
      el.appendChild(createCustomSplideArrows());
    }
    mountSplideOnce(el, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      pagination: false,
      arrows: true,
      drag: true,
      rewind: false,
      gap: '60px',
      breakpoints: {
        767: { perPage: 1 },
      },
    });
  });
}

function blogPagination() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-blog-next-page');
    if (!btn) return;

    e.preventDefault();
    const href = btn.getAttribute('data-href');
    if (!href) return;

    try {
      const res = await fetch(href, { method: 'GET' });
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const currentLoadMore = document.querySelector('.js-blog-load-more');
      if (currentLoadMore) currentLoadMore.remove();

      const row = document.querySelector('.js-blog-row');
      const newRow = doc.querySelector('.js-blog-row');
      if (row && newRow) {
        row.insertAdjacentHTML('beforeend', newRow.innerHTML);
        initBlogCarousels(row);
      }

      const wrapMore = document.querySelector('.js-blog-wrap-load-more');
      const newWrapMore = doc.querySelector('.js-blog-wrap-load-more');
      if (wrapMore && newWrapMore) {
        wrapMore.innerHTML = newWrapMore.innerHTML;
      }

      if (typeof initializeFadeInObserver === 'function') {
        initializeFadeInObserver();
      }
    } catch (err) {
      console.error('Pagination error:', err);
    }
  });
}

function init() {
  initBlogCarousels(document);
  blogPagination();
}

document.addEventListener('DOMContentLoaded', init);

document.addEventListener('shopify:section:load', (e) => {
  initBlogCarousels(e.target);
});
document.addEventListener('shopify:section:select', (e) => {
  initBlogCarousels(e.target);
});
document.addEventListener('shopify:block:select', (e) => {
  initBlogCarousels(e.target);
});
document.addEventListener('shopify:section:unload', (e) => {
  destroySplidesIn(e.target);
});
